export const API_ENDPOINTS = {
  chat: {
    // sendMessage: () => `https://chatbotinsightsdev.ckdigital.in/api/chat`,
    sendMessage: () => `chatbot`,
  },
};
